import entireVideo from '../../factories/entire-video';

export const entireVideoEnhancer = entireVideo('videoUpload');
